<ng-container *ngIf="!hasScales; else withScales">
  <ng-container *ngIf="hasTechnicalStops">
    <div class="segment-connection-technical">
      <app-segment-connection
        [type]="segmenTypeTechnicalStop"
        [notBorderRadius]="notBorderRadius"
        [message]="segmentTechnicalStopMessage$ | async">
      </app-segment-connection>
    </div>
  </ng-container>
  <ng-container *ngTemplateOutlet="luggageTooltipContent"></ng-container>
  <ng-container *ngIf="!isExcludedFromDuration">
    <app-segment-connection
      *ngIf="totalDuration"
      [type]="segmenTypeTotal"
      [notBorderRadius]="notBorderRadius"
      [message]="flightSegmentTotalMessage">
    </app-segment-connection>
  </ng-container>
</ng-container>

<ng-template #withScales>
  <ng-container *ngIf="hasTechnicalStops">
    <div class="segment-connection-technical">
      <app-segment-connection
        [type]="segmenTypeTechnicalStop"
        [notBorderRadius]="notBorderRadius"
        [message]="segmentTechnicalStopMessage$ | async">
      </app-segment-connection>
    </div>
  </ng-container>
  <ng-container *ngIf="isScaleElement; else segmentTotal">
    <app-segment-connection
      [type]="segmenTypeScale"
      [notBorderRadius]="notBorderRadius"
      [message]="segmentScaleMessage$ | async">
    </app-segment-connection>
  </ng-container>
  <ng-template #segmentTotal>
    <ng-container *ngTemplateOutlet="luggageTooltipContent"></ng-container>
    <ng-container *ngIf="!isExcludedFromDuration">
      <app-segment-connection
        *ngIf="totalDuration"
        [type]="segmenTypeTotal"
        [notBorderRadius]="notBorderRadius"
        [message]="flightSegmentTotalMessage">
      </app-segment-connection>
    </ng-container>
  </ng-template>
</ng-template>

<ng-template #luggageTooltipContent>
  <ng-content #luggageTooltip></ng-content>
</ng-template>
